export default __webpack_public_path__ + "static/media/calories.0169c2ea.svg";